import sget from 'xlvip-sget'
import { getCookie } from '~/plugins/xl-cookie'

function xlaPush(action, extdata = {}, category = 'web_game_center_event') {
  const extData = {
    referfrom:
      sget(Global, 'queries', 'referfrom') || getCookie('xwgame_referfrom'),
    actfrom: sget(Global, 'queries', 'actfrom') || getCookie('xwgame_actfrom'),
    is_login: getCookie('userid') && getCookie('sessionid') ? 1 : 0,
    is_vip: getCookie('isvip'),
    userid: getCookie('userid'),
    vip_type: [0, 2, 3, 5][getCookie('vip_type')],
    ...extdata
  }
  window.xla.push({
    type: 'event',
    category,
    action,
    extdata: extData
  })
  // eslint-disable-next-line no-console
  console.log(action, extData)
}

export default (_, inject) => {
  inject('xlaPush', xlaPush)
  inject('xlaGamePush', (action, extdata) =>
    xlaPush(action, extdata, 'game_official_website_event')
  )
  inject(
    'xlaGameReport',
    (action, extdata, category = 'game_official_website_event') =>
      xlaPush(action, extdata, category)
  )
  inject('hmtPush', (category, action, opt_label, opt_value = {}) => {
    _hmt.push([
      '_trackEvent',
      category,
      action,
      opt_label,
      JSON.stringify({
        ...opt_value,
        userid: getCookie('userid'),
        referfrom: getCookie('xwgame_referfrom'),
        actfrom: getCookie('xwgame_actfrom')
      })
    ])
  })
}
